import gql from 'graphql-tag'

export default gql`mutation ($user_id: Int!, $widgets: [DashboardWidgetInput]!){
  upsertUserDashboardWidgets(user_id: $user_id, widgets: $widgets){
    user_id
    dashboard_widgets {
      id
      description
      settings
    }
  }
}`